import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueCount: {
		id: 'software-reports.velocity-report.state.selectors.chart.issue-count',
		defaultMessage: 'Issue count',
		description: '',
	},
	storyPoint: {
		id: 'software-reports.velocity-report.state.selectors.chart.story-point',
		defaultMessage: 'Story point',
		description: '',
	},
	originalEstimate: {
		id: 'software-reports.velocity-report.state.selectors.chart.original-estimate',
		defaultMessage: 'Original estimate (Hours)',
		description: '',
	},
});
